var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#icon-ic_wrong';
                    var viewUrl = 'sprites.svg#view-icon-ic_wrong';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };